import * as React from "react"
const SvgSeo = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M11.5 14.357q.525 0 .988-.137a4 4 0 0 0 .912-.413l1.525 1.575a.62.62 0 0 0 .512.213.84.84 0 0 0 .538-.213.78.78 0 0 0 .237-.537.7.7 0 0 0-.212-.538l-1.55-1.55q.274-.425.413-.9a3.6 3.6 0 0 0 .137-1q0-1.474-1.037-2.487-1.038-1.013-2.463-1.013-1.424 0-2.463 1.013Q8 9.383 8 10.857q0 1.476 1.037 2.488 1.038 1.012 2.463 1.012m0-1.5q-.825 0-1.412-.587a1.93 1.93 0 0 1-.588-1.413q0-.825.588-1.412a1.93 1.93 0 0 1 1.412-.588q.8 0 1.4.588.6.587.6 1.412t-.588 1.413a1.93 1.93 0 0 1-1.412.587m-9.5 9a.97.97 0 0 1-.712-.287.97.97 0 0 1-.288-.713q0-.424.288-.712A.97.97 0 0 1 2 19.857h20q.424 0 .712.288a.97.97 0 0 1 .288.712.97.97 0 0 1-.288.713.97.97 0 0 1-.712.287zm2-3q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 16.857v-11q0-.824.587-1.412A1.93 1.93 0 0 1 4 3.857h16q.824 0 1.413.588.587.587.587 1.412v11a1.93 1.93 0 0 1-.587 1.413 1.93 1.93 0 0 1-1.413.587zm0-2h16v-11H4z" />
  </svg>
)
export default SvgSeo
